import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  userRoleForSelectedNetwork,
  crqRequiresPou,
  getIsOlaCrq,
  isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { navigationPropsShape } from 'AppSrc/core/components/forms/section-nav';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  REFERENCES_SECTION,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { refreshPouAction } from 'AppSrc/core/pou/pou-actions';
import { connect } from 'react-redux';
import { pou } from './pou';
import { project } from './project';
import { customer } from './customer';
import { incident } from './incident';
import { criticalCustomerList } from './critical-customer-list';

// Section ID (for the data layer)
const sectionId = REFERENCES_SECTION;
// Title for the main form
const sectionTitle = SECTION_TITLES[REFERENCES_SECTION];

const getShowPou = ({
  userRole,
  formData,
}) => {
  if (userRole !== COORDINATOR) {
    return false;
  }

  return crqRequiresPou(formData);
};

// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {

  const {
    // values = {},
    formData = {},
    // touched = {},
    userRoles,
  } = params;


  const currentFields = [];
  const userRole = userRoleForSelectedNetwork(formData, userRoles);
  // const isOlaCrq = getIsOlaCrq(formData);
  // const IsOlaCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const isOlaCrq = getIsOlaCrq(formData) || isOloByService;
  const isEmergencyCrq = isCrqEmergency(formData);
  const showPou = getShowPou({
    userRole,
    formData,
  });
  const isCreateCRQ = window.location.href.includes('create');
  if (showPou) {
    currentFields.push({
      ...defaultFieldLogic,
      componentData: pou,
      readOnly: true,
    });
  }
  // Incident field is mandatory for Emergency OLO CRQ
  if (isOlaCrq === true && isEmergencyCrq) {
    currentFields.push({
      ...defaultFieldLogic,
      componentData: incident,
      // req for create but not for edit
      optional: (isEmergencyCrq && isCreateCRQ) ? false : true,
      // readOnly: (isEmergencyCrq && !isCreateCRQ) ? true : false,
    });
  }
  if (isOlaCrq === false) {
    currentFields.push({
      ...defaultFieldLogic,
      componentData: project,
      optional: true,
    });
    currentFields.push({
      ...defaultFieldLogic,
      componentData: customer,
      optional: true,
    });
    currentFields.push({
      ...defaultFieldLogic,
      componentData: incident,
      // req for create but not for edit
      optional: (isEmergencyCrq && isCreateCRQ) ? false : true,
      // readOnly: (isEmergencyCrq && !isCreateCRQ) ? true : false,
    });
    currentFields.push({
      ...defaultFieldLogic,
      componentData: criticalCustomerList,
    });
  }

  return currentFields;
};

// generates the formSection!
const ReferencesSectionDisplay = React.memo(({
  // saves locally and goes to the next page
  handleSuccessfulSubmit,
  userRoles,
  formData,
  navigationProps,
  sectionIndex,
  editingStatus,
  refreshPou,
  refreshingPou,
}) => {
  useEffect(refreshPou, []);

  if (refreshingPou) {
    return (
      <div className="form-loader">
        <LoadingSpinner />
      </div>
    );
  }
  // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
  const filteredNavigationProps = {
    ...navigationProps,
    submitForm: null,
  };

  const formattedSectionTitle = prefixStringWithIndexPlusOne(sectionTitle, sectionIndex);

  return (
    <FormSection
      sectionTitle={formattedSectionTitle}
      sectionId={sectionId}
      getCurrentFields={getCurrentFields}
      userRoles={userRoles}
      formData={formData}
      navigationProps={filteredNavigationProps}
      handleSuccessfulSubmit={handleSuccessfulSubmit}
      editingStatus={editingStatus}
    />
  );
});

ReferencesSectionDisplay.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  userRoles: userRolesPropShape,
  formData: formDataShape,
  navigationProps: navigationPropsShape,
  sectionIndex: PropTypes.number,
  editingStatus: PropTypes.string,
  refreshPou: PropTypes.func,
  refreshingPou: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { refreshingPou } = state.pou;
  return ({
    refreshingPou,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  refreshPou() {
    const { editingStatus } = ownProps;
    // dispatch action to refresh POU if necessary
    dispatch(refreshPouAction(editingStatus));
  },
});

const ReferencesSection = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferencesSectionDisplay);

export {
  ReferencesSection,
  getCurrentFields,
  REFERENCES_SECTION,
};
